import { useTranslation } from "react-i18next";
import "./styles.css";

type ProductSummaryData = {
  creep_feeding?: boolean | null;
  trade_name: string;
  manufacturer: string;
  packaging_type: ProductPackagingType;
  bag_weight_kg: number | string | null;
  expected_consumption: number;
  supply_frequency: number;
};

export function ProductSummary({ product }: { product: ProductSummaryData }) {
  const { t, i18n } = useTranslation();
  return (
      <div className="body_resume">
        <div className="formContainerProduct">
          <label className="body_title">{t("formsV2.productSummary.creepFeeding")}</label>
          <label className="container_formResult">
            {typeof product.creep_feeding === "boolean"
              ? t(product.creep_feeding ? "formsV2.productSummary.yes" : "formsV2.productSummary.no")
              : "—"}
          </label>
        </div>
        <div className="formContainerProduct">
          <label className="body_title">{t("managementDialogs.tradeName")}</label>
          <label className="container_formResult">{product.trade_name}</label>
        </div>
        <div className="formContainerProduct">
          <label className="body_title">{t("managementDialogs.manufacturer")}</label>
          <label className="container_formResult">{product.manufacturer}</label>
        </div>
        <div className="formContainerProduct">
          <label className="body_title">{t("productPackaging.packaging")}</label>
          <label className="container_formResult">
            {t(product.packaging_type === "BAGGED" ? "formsV2.packagingBagged" : "formsV2.packagingBulk")}
          </label>
        </div>
        {product.packaging_type === "BAGGED" && (
          <div className="formContainerProduct">
            <label className="body_title">{t("formsV2.productSummary.bagWeight")}</label>
            <label className="container_formResult">
              {product.bag_weight_kg != null
                ? `${new Intl.NumberFormat(i18n.language).format(Number(product.bag_weight_kg))} kg`
                : "—"}
            </label>
          </div>
        )}
        <div className="formContainerProduct">
          <label className="body_title">{t("managementDialogs.consumption")}</label>
          <label className="container_formResult">
            {product.expected_consumption
              ? t("formsV2.productSummary.consumption", {
                  value: new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 20 }).format(product.expected_consumption),
                })
              : ""}
          </label>
        </div>
        <div className="formContainerProduct">
          <label className="body_title">{t("managementDialogs.frequency")}</label>
          <label className="container_formResult last">
            {product.supply_frequency
              ? t("formsV2.productSummary.frequency", { frequency: product.supply_frequency })
              : ""}
          </label>
        </div>
      </div>
  );
}
